import { toast } from "react-toastify";
import { all, fork, takeEvery } from "redux-saga/effects";
import { notificationsActionTypes } from "./actions";

function* addNotificationHandler(action) {
  yield toast(action.payload.message.detail ? action.payload.message.detail : action.payload.message, { type: toast.TYPE[action.payload.type.toUpperCase()] });
}

function* watchAddNotification() {
  yield takeEvery(notificationsActionTypes.addMessageNotificationCenter, addNotificationHandler);
}

export default function* notificationCenterSagas() {
  yield all([fork(watchAddNotification)]);
}
